import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'json-editor',
  templateUrl: './arm-json-editor.component.html',
  styleUrls: ['./arm-json-editor.component.scss']
})
export class ArmJsonEditorComponent implements OnInit {
  @Output() onApply = new EventEmitter<any>();
  @Input() group;

  jsonInput: string;
  errorMessage: string;
  isValid = false;

  constructor() {
  }

  ngOnInit(): void {
    this.jsonInput = this.group.requestBody;
    this.validateJSON();
  }

  validateJSON(): void {
    if (this.group.requestContentType === 'APPLICATION_JSON') {
      try {
        JSON.parse(this.jsonInput);
        this.errorMessage = 'valid json';
        this.isValid = true;
      } catch (e) {
        this.errorMessage = e.message;
        this.isValid = false;
      }
    }
  }

  beautifyJSON(): void {
    this.jsonInput = JSON.stringify(JSON.parse(this.jsonInput), null, 2);
  }

  applyJSON(): void {
    const finalBody = this.jsonInput;
    this.closeCustomValue();
    this.onApply.emit({finalBody, group: this.group});
  }

  cancel(): void {
    this.closeCustomValue();
  }

  private closeCustomValue(): void {
    this.group.isJsonEditorOpen = false;
  }
}
